module.exports = __webpack_public_path__ + "static/penn-clubs-shooting-yourself-in-the-foot-cover-82745e465e0b9d14bf27e1bc2f88ec11.png";